export default __webpack_public_path__ + "e9c96db042740ea4a1403642b600cbc7.svg";